export interface InteractionEvent {
  readonly id: string;
  readonly label: string;
  readonly timestamp: number;
}

export const createInteractionEvent = (id: string, label: string, now = Date.now()): InteractionEvent => ({
  id,
  label,
  timestamp: now
});

export const isTrackableElement = (element: Element | null): element is HTMLElement =>
  element instanceof HTMLElement && element.dataset.analyticsId !== undefined;

export const getTrackingPayload = (element: HTMLElement, now = Date.now()): InteractionEvent =>
  createInteractionEvent(element.dataset.analyticsId ?? 'unknown', element.textContent?.trim() ?? '', now);
